import React from 'react';

function StatsCard({ title, value, color, icon, iconBg, iconColor }) {
  return (
    <div className={`stats-card stats-card--${color}`}>
      <div className="stats-card-icon" style={{ background: iconBg || '#f3f4f6', color: iconColor || 'inherit' }}>
        {icon}
      </div>
      <div className="stats-card-content">
        <div className="stats-card-title">{title}</div>
        <div className="stats-card-value">{value}</div>
      </div>
    </div>
  );
}

export default StatsCard;
